// src/utils/saveFile.js
// Save-As dialog for generated documents.
//
// Uses the File System Access API when available (Chromium browsers, HTTPS
// origins). Falls back to the browser's default download behavior elsewhere.
// User cancellation is silent — no fallback download fires.

/**
 * @param {jsPDF} doc - the jsPDF instance
 * @param {string} suggestedName - default filename including extension
 */
export async function savePdfWithDialog(doc, suggestedName) {
  if (typeof window !== 'undefined' && typeof window.showSaveFilePicker === 'function') {
    try {
      const handle = await window.showSaveFilePicker({
        suggestedName,
        types: [
          { description: 'PDF Document', accept: { 'application/pdf': ['.pdf'] } },
        ],
      });
      const blob = doc.output('blob');
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return;
    } catch (err) {
      // User cancelled the picker — abort without falling back
      if (err && (err.name === 'AbortError' || err.code === 20)) return;
      // Real error (e.g., permission denied) — log and fall back
      console.warn('Save dialog failed, falling back to default download:', err);
    }
  }
  // Fallback: browser's default save-to-downloads behavior
  doc.save(suggestedName);
}
